<ng-container *transloco="let transloco">
  <div class="relative w-full h-full flex flex-col justify-center items-center gap-[20px]">
    <div class="w-full flex justify-center items-center p-[10px] text-[36px] font-[800]">{{ email }}</div>
    <div class="flex w-full flex-col justify-center items-center">
      <div class="w-full flex justify-center items-center text-center text-[16px] font-[500]">{{ 'Please complete the verification process by clicking the link in the email we sent to your address.' | transloco }}</div>
      <div class="flex w-full flex-row justify-between items-center"></div>
    </div>
    <!-- <div class="flex-none relative w-full h-[55px] flex flex-row gap-[14px]">
    <button class="w-full h-[60px] flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white" (click)="onClickResend()">Resend</button>
    <button class="w-full h-[60px] flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white" (click)="onClickCancel()">Cancel</button>
  </div> -->
    <button class="mt-5 w-full h-[60px] flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white" (click)="onClickCancel()">{{ 'Back' | transloco }}</button>
  </div>
</ng-container>
